import { enumBoxShapes, NS_SVG } from "../constants";
import { SVG_AddArc } from "./SVG_AddArc";
import { SVG_GetUniqueID } from "./SVG_GetUniqueID";
import { SVG_AddPair } from "./SVG_AddPair";

export function SVG_CreateBoxPath(bounds, boxShape) {
  var path = document.createElementNS(NS_SVG, "path");
  var idStr = SVG_GetUniqueID("path");
  path.setAttribute("id", idStr);
  var p = "";
  var r = bounds;

  switch (boxShape) {
    case enumBoxShapes.rectangle:
      p = SVG_AddPair("M", r.fLeft, r.fTop);
      p += SVG_AddPair("L", r.fRight, r.fTop);
      p += SVG_AddPair("L", r.fRight, r.fBottom);
      p += SVG_AddPair("L", r.fLeft, r.fBottom);
      p += SVG_AddPair("L", r.fLeft, r.fTop);
      p += "Z";
      break;
    case enumBoxShapes.snipCornerRectangle:
      p = SVG_AddPair("M", r.fLeft, r.fTop);
      p += SVG_AddPair("L", r.fRight - r.fCornerRadius, r.fTop);
      p += SVG_AddPair("L", r.fRight, r.fTop + r.fCornerRadius);
      p += SVG_AddPair("L", r.fRight, r.fBottom);
      p += SVG_AddPair("L", r.fLeft, r.fBottom);
      p += SVG_AddPair("L", r.fLeft, r.fTop);
      p += "Z";
      break;
    case enumBoxShapes.roundRectangle:
      p = SVG_AddPair("M", r.fLeft + r.fCornerRadius, r.fTop);
      p += SVG_AddPair("L", r.fRight - r.fCornerRadius, r.fTop);
      p += SVG_AddArc(r.fRight, r.fTop + r.fCornerRadius, r.fCornerRadius);
      p += SVG_AddPair("L", r.fRight, r.fBottom - r.fCornerRadius);
      p += SVG_AddArc(r.fRight - r.fCornerRadius, r.fBottom, r.fCornerRadius);
      p += SVG_AddPair("L", r.fLeft + r.fCornerRadius, r.fBottom);
      p += SVG_AddArc(r.fLeft, r.fBottom - r.fCornerRadius, r.fCornerRadius);
      p += SVG_AddPair("L", r.fLeft, r.fTop + r.fCornerRadius);
      p += SVG_AddArc(r.fLeft + r.fCornerRadius, r.fTop, r.fCornerRadius);
      p += "Z";
      break;
    case enumBoxShapes.roundSnipCornerRectangle:
      p = SVG_AddPair("M", r.fLeft, r.fTop);
      p += SVG_AddPair("L", r.fRight - r.fCornerRadius, r.fTop);
      p += SVG_AddArc(r.fRight, r.fTop + r.fCornerRadius, r.fCornerRadius);
      p += SVG_AddPair("L", r.fRight, r.fBottom);
      p += SVG_AddPair("L", r.fLeft, r.fBottom);
      p += SVG_AddPair("L", r.fLeft, r.fTop);
      p += "Z";
      break;
    case enumBoxShapes.boxGroup:
      p = SVG_AddPair("M", r[0], r[1]);
      for (var i = 0; i < r.length - 1; i += 2) {
        p += SVG_AddPair("L", r[i], r[i + 1]);
      }
      p += "Z";
      break;
  }

  path.setAttribute("d", p);

  return path;
}
